export const isEmptyTile = (value: string) => {
  let isEmpty = value === '---' || value === null || value === undefined || value == '';
  return isEmpty;
};
